<template>
    <div id="content" class="d-flex justify-content-center align-items-start gap-3 position-relative h-100">
        <div class="leaderboards row d-flex flex-fill">
            <div class="col-12 col-lg-6 mt-3 fade-down" v-for="(board, index) in boards">
                <div class="card bg-light h-100">
                    <div class="leaderboard-title d-flex justify-content-between">
                        <div class="d-flex flex-column">
                            <h3>{{ board.event_info.name }}</h3>
                            <h5>{{ board.event_info.grade_name }}
                                <span v-if="timeLeft[index] <= 0" class="text-finished">{{ $t('battle_finished') }}</span>
                                <span v-else><small>{{ $t('battle_end') }}</small>&nbsp;{{ timeLeft[index] }}</span>
                            </h5>
                        </div>
                        <div class="d-flex flex-column gap-1 align-items-center">
                            <p class="board-status" :class="board.event_info.enable_opponent ? 'starting' : 'stopped'">{{ board.event_info.enable_opponent ? $t('battle_starting') : $t('battle_stopped') }}</p>
                            <div class="playing"><i class="ito-icon ito-user"></i>{{ board.event_info.number_playing || 0 }}</div>
                        </div>
                    </div>
                    <div class="leaderboard-table  flex-fill">
                        <div class="h-100 d-flex justify-content-center align-items-center" v-if="board.leader_board.length <= 0">
                            <p class="text-center text-bold">{{ $t('no_leaderboard_record') }}</p>
                        </div>
                        <table class="ranking-board" v-else>
                            <TransitionGroup name="fade" tag="tbody">
                                <tr v-for="user in board.leader_board" :key="user.student_id">
                                    <td>
                                        <span class="number">{{ user.rank }}</span>
                                    </td>
                                    <td>
                                        <div class="name">
                                            {{ user.full_name || user.username }}
                                            <small>{{ user.username }}</small>
                                        </div>
                                    </td>

                                    <td v-if="board.event_info.ranking_type =='trophy'" >
                                        <div class="tropphies">
                                            {{ user.trophy }}
                                            <img class="icon-gem-bag" :src="user.trophy_url" alt="" v-if="user.trophy_url">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="28" viewBox="0 0 25 28" fill="none" v-else>
                                                <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M19.9216 3.73828V2.34881H20.4126H20.418C20.7037 2.34881 20.9379 2.12077 20.9379 1.83002V0.518791C20.9379 0.233741 20.7094 0 20.418 0H20.4126H19.2183H4.58171C4.29606 0 4.06183 0.233741 4.06183 0.518791V1.83002C4.06183 2.11507 4.29606 2.34881 4.58171 2.34881H5.07912V3.73828H1.00527C0.496811 3.73828 0.0683331 4.13165 0.0226287 4.63904C0.0112026 4.73025 -0.171616 6.91374 0.731046 9.34806C1.55411 11.5734 3.45445 14.42 7.82851 15.5162C8.50626 16.0651 9.28275 16.4972 10.1271 16.7818L10.552 17.4812C11.0205 18.2508 11.2718 19.1743 11.2718 20.1207C11.2718 20.6965 11.1804 21.2723 10.9976 21.8082L10.7356 22.5781H9.40431C8.62162 22.5781 7.99318 23.2109 7.99318 23.9863V25.2871H6.02747C5.82751 25.2871 5.66184 25.4524 5.66184 25.652V27.6359C5.66184 27.8355 5.82751 28.0008 6.02747 28.0008H17.8431H18.9733H18.9743C19.1743 28.0008 19.3399 27.8355 19.3399 27.6359V25.652C19.3399 25.4524 19.1743 25.2871 18.9743 25.2871H18.9733H17.8431H17.0141V23.9863C17.0141 23.2052 16.3799 22.5781 15.603 22.5781H15.5972H14.4889H14.2652L14.0033 21.8082C13.8204 21.2723 13.729 20.7022 13.729 20.1207C13.729 19.7582 13.7659 19.399 13.8371 19.0509C13.9528 18.4896 14.1592 17.9561 14.4483 17.4812H14.4432L14.8666 16.7841C15.7138 16.4996 16.4929 16.0665 17.1726 15.516C21.5459 14.4195 23.4459 11.5732 24.2689 9.34806C25.1716 6.91374 24.9888 4.73025 24.9774 4.63904C24.9316 4.13165 24.5032 3.73828 23.9947 3.73828H19.9216ZM5.07912 9.76349C5.07912 10.7138 5.25883 11.6225 5.58617 12.4576C4.2158 11.5792 3.22001 10.3307 2.61064 8.72665C2.24501 7.76889 2.09075 6.84532 2.0222 6.1384C1.99935 5.91036 2.18216 5.71083 2.41068 5.71083H5.07912V9.76349ZM19.9216 9.76349V5.71083H22.5893C22.8178 5.71083 23.0006 5.91036 22.9778 6.1384C22.9092 6.84532 22.755 7.76889 22.3893 8.72665C21.7801 10.3303 20.7847 11.5785 19.4149 12.4569C19.742 11.622 19.9216 10.7135 19.9216 9.76349Z"
                                                    fill="url(#paint0_linear_3851_105402)" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_3851_105402" x1="4.37357" y1="0.350007" x2="18.9408" y2="27.7915" gradientUnits="userSpaceOnUse">
                                                        <stop offset="0.00273632" stop-color="#FFD800" />
                                                        <stop offset="1" stop-color="#FFB000" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="point">
                                            <span v-html="convertPoint(user.point)"></span>
                                            <small>{{ $t('point') }}</small>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="gem me-3" v-if="user.reward_gems > 0">
                                            {{ user.reward_gems }}
                                            <img class="icon-gem-bag" :src="user.thumbnail_url" alt="" v-if="user.thumbnail_url">
                                        </div>
                                    </td>
                                </tr>
                            </TransitionGroup>
                        </table>

                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center gap-3 position-sticky top-0">
            <div class="d-flex gap-3">
                <button class="ito-btn ito-btn-primary" @click="prevPage()" :disabled="page <= 1 || pagesize == 10">
                    <i class="icon-prev-circle"></i>
                </button>
                <button class="ito-btn ito-btn-primary" @click="nextPage()" :disabled="page >= 2 || pagesize == 10">
                    <i class="icon-next-circle"></i>
                </button>
            </div>
            <div class="d-flex flex-column gap-3">
                <button class="ito-btn ito-btn-block ito-btn-secondary" @click="changeView()">{{ pagesize == 5 ? $t('show_10_rows') : $t('show_5_rows') }}</button>
                <div class="d-flex gap-3">
                    <button class="ito-btn ito-btn-warning text-capitalize" @click="enableFindOpponents(0)" :disabled="!authToken">{{ $t('battle_stop') }}</button>
                    <button class="ito-btn ito-btn-success text-capitalize" @click="enableFindOpponents(1)" :disabled="!authToken">{{ $t('battle_start') }}</button>
                </div>
            </div>
        </div>
        <!-- begin::Modals -->
        <div class="modal fade" id="notification" tabindex="-1" aria-labelledby="notificationLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-0">
                        <h5 class="modal-title popup-title flex-fill text-center" id="notificationLabel">{{ $t(notification.title) }}</h5>
                        <button type="button" class="close-popup" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body px-3 py-0">
                        <h6 class="text-center">{{ $t(notification.message) }}</h6>
                    </div>
                    <div class="modal-footer d-flex justify-content-center border-0">
                        <button class="btn ito-btn-primary px-5" data-bs-dismiss="modal" aria-label="Ok">
                            {{ $t('ok') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- end::Modals -->
    </div>
</template>
<script>
import axios from "axios";
import NavBarAuth from "./NavBarAuth";

export default {
    name: "LivestreamLeaderboard",
    components: {
        NavBarAuth,
    },
    data() {
        return {
            boards: [],
            timeLeft: [],
            page: 1,
            pagesize: 5,
            authToken: this.$route.params.token || undefined,
            notification: {
                title: '',
                message: '',
            },
        }
    },

    created() {
    },

    mounted() {
        this.fetch();
    },

    methods: {
        async fetch() {
            this.clearAllInterval();
            const vm = this;
            const url = process.env.VUE_APP_API_URL + "/battle-game/event-leader-board";
            const params = {
                event_ids: '[' + (this.$route.params.boards_ids).split('-').toString() + ']',
                page: this.page,
                pagesize: this.pagesize
            };
            this.$store.commit("setLoading", true);

            await axios.get(url, { params })
                .then(function (response) {
                    if (response.data.code != 0) {

                        return;
                    } else {
                        var results = response.data.results
                        vm.boards = results;
                        results.forEach((element, index) => {
                            var timeRemain = element.event_info.time_remaining
                            vm.countdownTimer(index, timeRemain)
                        });
                    }
                })
                .catch(function (error) {
                    console.error(error);
                });
            this.$store.commit("setLoading", false);
            setTimeout(this.fetch, 5000);
        },

        async enableFindOpponents(value) {
            const vm = this;
            const url = process.env.VUE_APP_API_URL + "/battle-game/update-find-opponent";
            const config = {
                headers: { Authorization: `Bearer ${this.authToken}` }
            };
            var formData = new FormData;
            formData.append('event_ids', '[' + (this.$route.params.boards_ids).split('-').toString() + ']')
            formData.append('enable_opponent', value);
            this.$store.commit("setLoading", true);
            await axios.post(url, formData, config)
                .then(function (response) {
                    if (response.data.code != 0) {
                        vm.notification.title = vm.$i18n.t('error');
                        vm.notification.message = vm.$i18n.t(response.data.error_code);
                        $('#notification').modal('show')
                    } else {
                        if (value == 1) {
                            vm.notification.title = vm.$i18n.t('battle_game_started_title');
                            vm.notification.message = vm.$i18n.t('battle_game_started_content');
                        } else {
                            vm.notification.title = vm.$i18n.t('battle_game_stopped_title');
                            vm.notification.message = vm.$i18n.t('battle_game_stopped_content');
                        }
                        $('#notification').modal('show')
                        vm.fetch()
                    }
                    return;
                })
                .catch(function (error) {
                    console.error(error);
                });
            this.$store.commit("setLoading", false);
        },

        convertPoint(point) {
            point = (point.toFixed(2) + "").split(".");
            var point_text = point[0] + ".<span style='font-size: 14px; font-weight: 700!important; '>" + point[1] + "</span>"
            return point_text
        },

        countdownTimer(index, timestamp) {
            const vm = this;
            var duration, interval = 1000, intervalId;
            setInterval(() => {
                duration = moment.duration(timestamp -= 1, 'seconds');
                if (duration.asSeconds() <= 0) {
                    clearInterval(intervalId);
                    vm.timeLeft.splice(index, 1, 0)
                } else {
                    vm.timeLeft.splice(index, 1, this.zeroPadd(duration.months()) + ' ' + this.$i18n.t('month') + ' ' + this.zeroPadd(duration.days()) + ' ' + this.$i18n.t('days') + ' ' + this.zeroPadd(duration.hours()) + ":" + this.zeroPadd(duration.minutes()) + ":" + this.zeroPadd(duration.seconds()));
                }
            }, interval);

        },

        zeroPadd(num) {
            return num.toString().padStart(2, '0')
        },

        changeView() {
            this.pagesize = this.pagesize == 5 ? 10 : 5;
            this.page = 1;
            this.fetch();
        },

        prevPage() {
            this.page -= 1;
            this.fetch()
        },

        nextPage() {
            this.page += 1;
            this.fetch()
        },

        clearAllInterval() {
            const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }
        }
    }
}
</script>
<style scoped>
.leaderboards {
    margin: 0 auto;
}

.leaderboard-title {
    padding: 10px 20px;
}

.leaderboard-title h3 {
    font-size: 18px;
    font-weight: 900;
    text-align: left;
    color: #FF7800;
    ;
}

.leaderboard-title h5 {
    font-size: 14px;
    font-weight: 900;
    text-align: left;
    color: #14233F;
}

.leaderboard-title small {
    font-size: 8px;
    font-weight: 400;
}

.leaderboard-title span {
    font-size: 12px;
    font-weight: 700;

}

.leaderboard-title img {
    width: 100px;
    height: 44px;
    border-radius: 4px;
    box-shadow: 4px 4px 0px 0px #00000012;
}

.leaderboard-table {
    padding: 0px 20px 20px 20px;
}



.ranking-board {
    border-radius: 8px;
    width: 100%;
    gap: 2px;
    overflow-y: auto;
    border-collapse: collapse;
    text-align: left;
}

.ranking-board tr::after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: #FFF;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.10);
}

.ranking-board tr {
    min-height: 60px;
    border: solid transparent;
    border-width: 2px 0;
    color: #14233F;
    font-size: 14px;
    font-weight: 700;
    position: relative;
}



.ranking-board tr.active::after {
    background: #98C923;
}

.ranking-board tr:first-child td:first-child {
    border-radius: 8px 0 0 8px;
}

.ranking-board tr:first-child td:last-child {
    border-radius: 0 8px 8px 0;
}

.ranking-board tr .number {
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    color: #0D0D0D;
}

.ranking-board tr .avatar {
    position: relative;
    width: 44px;
    height: 44px;
    box-shadow: none;
}

.ranking-board tr .avatar img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
}

.ranking-board tr .avatar .emotion {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 20px;
    height: 20px;
}

.ranking-board tr .avatar .emotion img {
    border-radius: 50%;
    border: solid 2px #FFF;
    width: 100%;
    height: 100%;
}

.ranking-board tr .name {
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
    color: #14233F;
}

.ranking-board tr .name small {
    font-size: 8px;
    font-weight: 400;
    text-align: left;
    color: #14233F;
}

.ranking-board tr .point {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
}

.ranking-board tr .point span {
    font-size: 18px;
    font-weight: 700 !important;

}



.ranking-board tr .point small {
    font-size: 12px;
}


.ranking-board tr .tropphies {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    font-size: 18px;
    font-weight: 700;
    text-align: right;
    color: #14233F;
}

.ranking-board tr .tropphies img {
    width: 25px;
    height: 28px;

}

.ranking-board tr .gem {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #14233F;
    text-align: right;
    justify-content: flex-end;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.4px;
}

.ranking-board tr td {
    position: relative;
    background: transparent;
    z-index: 2;
    padding: 5px;
}

.ranking-board tr td:last-child {
    width: 20% !important;

}

.ranking-board tr .gem img {
    width: 28px;
    height: 28px;
}

.icon-gem-bag {
    width: 52px;
    height: 52px;
}

.icon-next-circle {
    content: url('/public/themes/ito/images/battlegame/next-circle.svg');
    width: 24px;
    height: 24px;
}

.icon-prev-circle {
    content: url('/public/themes/ito/images/battlegame/next-circle.svg');
    width: 24px;
    height: 24px;
    transform: rotate(180deg);
}

.text-finished {
    color: #FF0000A6;
}

.playing {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: var(--primary);
}

.board-status {
    font-size: 14px;
    font-weight: 700;
    text-align: right;
    text-transform: capitalize;
}

.board-status.starting {
    color: #50CE05;
}

.board-status.stopped {
    color: #F74737;
}

/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: scaleY(0.01) translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
    position: absolute;
}
</style>